import { Component, Event, Prop, h, type EventEmitter, Listen } from '@stencil/core';
import type { IConversationalSearchStrategyData } from '../../../strategies/types/conversational-search-srategy-data.type';
import * as storageHelpers from '../conversational-search-logic/storage-manager/storage-manager-helpers';
import type { labelProviderInterface } from '../../../LabelProviderInterface';

@Component({
  tag: 'uiaas-search-widget-conversational-search-chat-elements-wrapper',
  styleUrl: 'conversational-search-chat-elements-wrapper.scss',
  shadow: true,
})
export class WidgetConversationalSearchChatElementsWrapper {
  @Prop() readonly conversationalSearchStrategyData: IConversationalSearchStrategyData['params'];
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly language: string;
  @Prop() readonly country: string;
  @Prop() readonly query: string;
  @Prop() readonly apigeeAuth: string;
  @Prop() readonly apigeeTokenUrl: string;

  @Event({
    eventName: 'conversational-search:cta-action',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    conversationalSearchCtaActionEventEmitter: EventEmitter<{ isChatVisible: boolean }>;

  @Listen('guided:SearchCompleted', { target: 'window' })
  handleReloadAndSubmitAction() {
      if (!storageHelpers.getTermsAndConditionsSessionStorageValue() && storageHelpers.getUIDSessionStorageValue()) {
        // Refresh token for not accepting terms and conditions and changed query
        storageHelpers.removeUIDSessionStorageValue();
      }
  }

  @Listen('beforeunload', { target: 'window' })
  handleReload() {
      storageHelpers.removeChatActionSessionStorageValue();
      storageHelpers.removeUIDSessionStorageValue();
  }

  @Listen('conversational-search:user-new-conversation', { target: 'window' })
  userNewConversationHandler() {
      storageHelpers.removeUIDSessionStorageValue();
  }

  render() {
      return this.conversationalSearchStrategyData.isConversationalSearchActive ? (
        <section class="conversational-search-chat-elements-wrapper">
          <uiaas-search-widget-conversational-search-chat-widget
            labelProvider={(e, f) => this.labelProvider(e, f)}
            country={this.country}
            language={this.language}
            searchQuery={this.query}
            apigeeAuth={this.apigeeAuth}
            apigeeTokenUrl={this.apigeeTokenUrl}
            conversationalSearchProductsEndpoint={this.conversationalSearchStrategyData.conversationalSearchProductsEndpoint}
            conversationalSearchMedaliaFormId={this.conversationalSearchStrategyData.conversationalSearchMedaliaFormId}
            conversationalSearchBrandUrl={this.conversationalSearchStrategyData.conversationalSearchBrandUrl}
            brand={this.conversationalSearchStrategyData.brand}
          />
          <uiaas-search-widget-conversational-search-overlay labelProvider={(e, f) => this.labelProvider(e, f)} />
        </section>
      ) : '';
  }
}
